export default __webpack_public_path__ + "static/media/curriculumMo3.2b654750.jpg";